export const cropPublicId = (publicId: string) =>
    publicId[0] === '@' ? publicId.substring(1) : publicId;
